import * as React from "react";

type Props = {
  className: string;
  alt?: string | null | undefined;
  src: string;
  styles?: Record<string, any>;
  onLoad?: () => void;
  showErrorComponent: () => void;
};

type State = {
  retryCount: number;
};

const RETRY_LIMIT = 5;

export default class ImageComponent extends React.PureComponent<Props, State> {
  state = {
    retryCount: 0
  };

  handleError = (e: Error) => {
    if (this.state.retryCount < RETRY_LIMIT) {
      this.setState((prevState: State) => ({
        retryCount: prevState.retryCount + 1
      }));
    } else {
      this.props.showErrorComponent();
    }
  };

  render() {
    const { className, alt, src, styles, onLoad } = this.props;
    return (
      <img
        key={`image-${src}-retry-${this.state.retryCount}`}
        className={className}
        alt={alt!}
        src={src}
        style={styles}
        onError={this.handleError as any}
        onLoad={onLoad}
      />
    );
  }
}
